import React from 'react'

require ( './corporate.scss' )
require ( './mobile_corporate.scss' )

export default class Corporate extends React.Component { 
    state = {}
    
    constructor(props, context) {
        super(props, context);
        this.pinggu=this.pinggu.bind(this);
    }

    componentDidMount(){
        this.setState({offsetWidth: document.body.offsetWidth})
    }
    
    render() {
        // console.log(this.props)
        // console.log(document.body.offsetWidth)
        if(this.state.offsetWidth>=1200){
             return ( 
            <div className = "serviceContainer">
                <div className = "Title">
                    <p>服务领域</p>
                    <p>Corporate Services</p>
                    <img src = { require ( '../../../assets/common/images/biaotizhuangshi.png' ) } alt=""/>
                </div>
                <div className = "Text">
                    <p>四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                </div>
                <div className = "Image">
                    <ul>
                        <li className="app">
                            <img className="appImg" src = { require ( '../../../assets/common/images/APPkaifa-lan.png' ) }  alt="APP开发"/>
                            <img className="appHoverImg" src = { require ( '../../../assets/common/images/APPkaifa-bai.png' ) }  alt="APP开发"/>
                            <p>APP开发</p>
                            <span></span>
                        </li>
                        <li className="wewat">
                            <img className="wewatImg" src = { require ( '../../../assets/common/images/weixin-lan.png' ) }  alt="微信开发"/>
                            <img className="wewatHoverImg" src = { require ( '../../../assets/common/images/weixin-bai.png' ) }  alt="微信开发"/>
                            <p>微信开发</p>
                            <span></span>
                        </li>
                        <li className="saas">
                            <img className="saasImg" src = { require ( '../../../assets/common/images/dianshangSaaS-lan.png' ) }  alt="电商SaaS"/>
                            <img className="saasHoverImg" src = { require ( '../../../assets/common/images/dianshangSaaS-bai.png' ) }  alt="电商SaaS"/>
                            <p>电商SaaS</p>
                            <span></span>
                        </li>
                        <li className="pc">
                            <img className="pcImg" src = { require ( '../../../assets/common/images/wangzhankaifa-lan.png' ) }  alt="网站开发"/>
                            <img className="pcHoverImg" src = { require ( '../../../assets/common/images/wangzhankaifa-bai.png' ) }  alt="网站开发"/>
                            <p>网站开发</p>
                            <span></span>
                        </li>
                    </ul>
                </div>
                <div className = "Bottom" onClick={this.pinggu}>
                    <p>价格评估</p>
                </div>
            </div>
            )
        }else{
            return(
                <div className = "Mobile_Service">
                    <p className = "Mobile_Title">服务领域</p>
                    <p className = "Mobile_SubTitle">Corporate Services</p>
                    <img src = { require( '../../../assets/common/images/biaotizhuangshi.png' ) } alt=""/>
                    <p className = "Mobile_Text">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                    <ul className = "Mobile_List">
                        <li className = "fl">
                            <img src = { require( '../../../assets/common/images/APPkaifa-lan.png' ) } alt=""/>
                            <p className = "Mobile_Head">APP开发</p>
                            <p className = "Mobile_Line"></p>
                        </li>
                        <li className = "fr">
                            <img src = { require('../../../assets/common/images/weixin-lan.png') } alt=""/>
                            <p className = "Mobile_Head">微信开发</p>
                            <p className = "Mobile_Line"></p>
                        </li>
                        <li className = "fl">
                            <img src = { require( '../../../assets/common/images/dianshangSaaS-lan.png' ) } alt=""/>
                            <p className = "Mobile_Head">电商SaaS</p>
                            <p className = "Mobile_Line"></p>
                        </li>
                        <li className = "fr">
                            <img src = { require('../../../assets/common/images/wangzhankaifa-lan.png') } alt=""/>
                            <p className = "Mobile_Head">网站开发</p>
                            <p className = "Mobile_Line"></p>
                        </li>
                    </ul>
                    <button>价格评估</button>
                </div>
            )
        } 
    }
    pinggu(){
        this.props.CorporateCallback(true)
    }
} 